import emptyTasks from "@/assets/images/icons/svg/empty-tasks.svg";

export const iconMap = {
	"emptyTasks": emptyTasks.id,
};
